import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AnalyticsService } from '../../../../app/core/services/analytics/analytics.service';

@Component({
  selector: 'app-session-expired-modal-error',
  templateUrl: './session-expired-modal-error.component.html',
  styleUrls: ['./session-expired-modal-error.component.scss']
})
export class SessionExpiredModalErrorComponent {
  constructor(private oauthService: OAuthService, private analyticsService: AnalyticsService) {}

  logoutAndReload() {
    this.analyticsService.trackError('erro:sessao-expirada');
    this.oauthService.logOut(true);
    location.reload();
  }
}
